<template>
  <div class="modal-comp">
    <slot name="trigger"></slot>
    <!-- Modal -->
    <div
      class="modal fade"
      :style="'overflow: scroll;' + styleClass"
      id="exampleModalLong"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      :aria-hidden="aria"
    >
      <div class="modal-dialog" role="document">
          <slot name="header"></slot>
        <div class="modal-content" :class="classes">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Modal",
  props: {
    classes: {
      type: String,
      default: "bg-white",
    },
    aria:{ type: String, default: "true" },
    styleClass: String,
  },
};
</script>
<style lang="scss" scoped>
.modal {
  height: 100vh;
  box-sizing: border-box;
  background: rgba(1, 4, 26, 0.48);
}
.modal-comp {
  position: relative;
}
.bg-white {
  background: #fff !important;
}
.modal-content {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: fit-content;
  margin: auto;
  width: max-content;
  box-sizing: border-box;
}
</style>
